import { AppNotification } from '../types/notifications'

const minutesAgo = (minutes: number) =>
  new Date(Date.now() - minutes * 60 * 1000)

export const notifications: AppNotification[] = [
  {
    id: 1,
    severity: 'critical',
    category: 'security',
    title: 'New sign-in from an unrecognized device',
    message:
      'Your admin account was accessed from a Windows device in Denver, CO at 6:42 AM MST. If this was not you, reset your password and review active sessions.',
    source: 'Security',
    timestamp: '12 minutes ago',
    date: minutesAgo(12),
    read: false,
    actionKind: 'review',
    actionLabel: 'Review sign-in activity',
    actionConfirmation:
      'Opened your recent sign-in activity. You can end any session you do not recognize from there.',
  },
  {
    id: 2,
    severity: 'warning',
    category: 'system',
    title: 'Single sign-on certificate expires in 14 days',
    message:
      'The SAML signing certificate for your organization expires on August 18. Learners will not be able to sign in until an updated certificate is uploaded.',
    source: 'Platform',
    timestamp: '2 hours ago',
    date: minutesAgo(120),
    read: false,
    actionKind: 'review',
    actionLabel: 'View integration details',
    actionConfirmation:
      'Opened your single sign-on configuration so you can upload the renewed certificate.',
    reference: 'Integration · SAML SSO',
  },
  {
    id: 3,
    severity: 'info',
    category: 'support',
    title: 'Support replied to your ticket about login errors',
    message:
      'Priya from Platform Support responded: “We have identified the cause of the intermittent login errors and deployed a fix. Please confirm whether your learners can now sign in normally.”',
    source: 'support@learningplatform.com',
    timestamp: '4 hours ago',
    date: minutesAgo(240),
    read: false,
    actionKind: 'reply',
    actionLabel: 'Reply to support',
    actionConfirmation:
      'Your reply was sent to Platform Support. They typically respond within one business day.',
    reference: 'Ticket #48210',
  },
  {
    id: 4,
    severity: 'warning',
    category: 'account',
    title: '12 of 250 learner seats remaining',
    message:
      'Your organization has 238 active learners. Once all seats are used, new learners cannot be invited until seats are added.',
    source: 'Account & Billing',
    timestamp: '8 hours ago',
    date: minutesAgo(480),
    read: false,
    actionKind: 'review',
    actionLabel: 'Review seat usage',
    actionConfirmation:
      'Opened your seat usage summary. Contact your account manager to add seats.',
  },
  {
    id: 5,
    severity: 'warning',
    category: 'system',
    title: 'Scheduled platform maintenance this weekend',
    message:
      'Maintenance is scheduled for Saturday, August 8 from 2:00 AM to 6:00 AM EST. Assessments and reporting will be unavailable during this window.',
    source: 'Platform',
    timestamp: '1 day ago',
    date: minutesAgo(60 * 26),
    read: false,
    actionKind: 'none',
  },
  {
    id: 6,
    severity: 'success',
    category: 'report',
    title: 'Monthly analytics report is ready',
    message:
      'Your July 2026 organization analytics report has finished generating and is available to download or share.',
    source: 'Reports',
    timestamp: '1 day ago',
    date: minutesAgo(60 * 30),
    read: true,
    actionKind: 'download',
    actionLabel: 'Download report',
    actionConfirmation:
      'Your July 2026 analytics report has been downloaded as a PDF.',
    reference: 'July 2026 · Organization summary',
  },
  {
    id: 7,
    severity: 'success',
    category: 'system',
    title: 'Learner import completed',
    message:
      '238 of 240 rows imported successfully. Two rows were skipped because of duplicate email addresses.',
    source: 'Platform',
    timestamp: '2 days ago',
    date: minutesAgo(60 * 50),
    read: true,
    actionKind: 'review',
    actionLabel: 'View import results',
    actionConfirmation:
      'Opened the import results so you can correct the two skipped rows.',
    reference: 'learners-august.csv',
  },
  {
    id: 8,
    severity: 'info',
    category: 'account',
    title: 'August invoice is available',
    message:
      'Invoice INV-2026-0812 for $4,980.00 is available. Payment is scheduled automatically for August 15.',
    source: 'Account & Billing',
    timestamp: '3 days ago',
    date: minutesAgo(60 * 74),
    read: true,
    actionKind: 'download',
    actionLabel: 'Download invoice',
    actionConfirmation: 'Invoice INV-2026-0812 has been downloaded as a PDF.',
    reference: 'INV-2026-0812',
  },
  {
    id: 9,
    severity: 'info',
    category: 'account',
    title: 'Updated data processing terms',
    message:
      'Our data processing agreement was updated on August 1 to cover new regional storage options. No action is required, but your legal team may want a copy.',
    source: 'Account & Billing',
    timestamp: '4 days ago',
    date: minutesAgo(60 * 98),
    read: true,
    actionKind: 'download',
    actionLabel: 'Download agreement',
    actionConfirmation:
      'The updated data processing agreement has been downloaded as a PDF.',
  },
  {
    id: 10,
    severity: 'success',
    category: 'support',
    title: 'Support ticket closed: report export formatting',
    message:
      'Your ticket about column formatting in exported reports has been resolved and closed. Reopen it if the issue returns.',
    source: 'support@learningplatform.com',
    timestamp: '6 days ago',
    date: minutesAgo(60 * 146),
    read: true,
    actionKind: 'reply',
    actionLabel: 'Reopen ticket',
    actionConfirmation:
      'Platform Support has been notified and your ticket is open again.',
    reference: 'Ticket #47755',
  },
]
